<script setup>
import router from '../../routes/index';
import LucideIcon from '../LucideIcon.vue';
const props = defineProps({
  backUrl: {
    type: [String, Object],
    default: '',
  },
  buttonLabel: {
    type: String,
    default: '',
  },
  compact: {
    type: Boolean,
    default: false,
  },
});

const goBack = () => {
  if (props.backUrl !== '') {
    router.push(props.backUrl);
  } else {
    router.go(-1);
  }
};

const buttonStyleClass = props.compact
  ? 'text-sm text-slate-600 dark:text-slate-300'
  : 'text-base text-hichat-500 dark:text-white';
</script>

<template>
  <button
    class="flex items-center p-0 font-normal cursor-pointer"
    :class="buttonStyleClass"
    @click.capture="goBack"
  >
    <LucideIcon name="chevron-left" size="24" class="-ml-1" />
    {{ buttonLabel}}
  </button>
</template>
